var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menus[2])?_c('div',{attrs:{"id":"condition"},domProps:{"innerHTML":_vm._s(_vm.menus[2].menuText)}},[_vm._v(" 投稿要求 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }